import { convertDateToEpochUTC } from "../../../../helper/DateConverters";

export const defaultFormValues = {
  projectKeyName: null,
  date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
  location: null,
  vehicleRegistration: null,
  teamMember1: {
    userID: null,
    displayName: null,
  },
  teamMember2: {
    userID: null,
    displayName: null,
  },
  additionalTeamMembers: [],
  keyPlantDetails: null,
  activity: null,
  emergencyDetails: {
    aAndE: null,
    others: null,
    emergencyContact: null,
    isFirstAiderAvailable: null,
    isFirstAidKitAvailable: null,
  },
  startWorkAssessment: {
    checklist: [
      {
        label:
          "Have all team members read, understood and agreed on the risk assessment and method statement.    ",
        value: null,
        name: "handlingEquipment",
      },
      {
        label: "Have all team membersreceived an induction?",
        value: null,
        name: "drivingAssessment",
      },
      {
        label: "Is there at least one trained NRSWA Operative on site?",
        value: null,
        name: "highwayCodeTest",
      },
      {
        label:
          "Are team members trained, and have an in-date trainings (e.g. CSR, confined space etc.) and competent?",
        value: null,
        name: "teamMembersTrained",
      },
      {
        label:
          "Does the team have PPE as defined within Risk Assessments & Method Statements?",
        value: null,
        name: "issueOfPPE",
      },
      {
        label:
          "Is the pre-use inspection form being filled out each day for the equipment?  ",
        value: null,
        name: "preUseInspection",
      },
      {
        label:
          "Are the operatives trained to carry out confined space entry if needed?  ",
        value: null,
        name: "confinedSpaceEntryTraining",
      },
      {
        label:
          "For confined space entry is permit for confined space being filled out?",
        value: null,
        name: "confinedSpaceEntryPermit",
      },
    ],
    riskelements: [
      {
        label: "Pedestrians/Public Access/Egress",
        value: null,
        name: "pedestrianPublicEgress",
      },
      {
        label: "COSHH Materials (i.e. chlorus, cement) ",
        value: null,
        name: "coshhMaterials",
      },
      {
        label: "Environmental (i.e. dust, waste, spillage)",
        value: null,
        name: "environmental",
      },
      { label: "Tool & Equipment ", value: null, name: "toolAndEquipment" },
      {
        label: "Underfoot Hazards(i.e. wet,sloping ground, footpath boards)",
        value: null,
        name: "underfootHazards",
      },
      { label: "Confined Space", value: null, name: "confinedSpace" },
      {
        label: "Working on Live Road",
        value: null,
        name: "workingOnLiveRoad",
      },
      { label: "Night Working", value: null, name: "nightWorking" },
      {
        label: "Traffic Management Authorization",
        value: null,
        name: "trafficManagementAuthorization",
      },
    ],
  },
};
